var _mask, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDragPoints({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1643:13831",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4C3.60457 4 4.5 3.10457 4.5 2C4.5 0.895431 3.60457 0 2.5 0C1.39543 0 0.5 0.895431 0.5 2C0.5 3.10457 1.39543 4 2.5 4ZM2.5 12C3.60457 12 4.5 11.1046 4.5 10C4.5 8.89543 3.60457 8 2.5 8C1.39543 8 0.5 8.89543 0.5 10C0.5 11.1046 1.39543 12 2.5 12ZM12.5 2C12.5 3.10457 11.6046 4 10.5 4C9.39543 4 8.5 3.10457 8.5 2C8.5 0.895431 9.39543 0 10.5 0C11.6046 0 12.5 0.895431 12.5 2ZM10.5 12C11.6046 12 12.5 11.1046 12.5 10C12.5 8.89543 11.6046 8 10.5 8C9.39543 8 8.5 8.89543 8.5 10C8.5 11.1046 9.39543 12 10.5 12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4C3.60457 4 4.5 3.10457 4.5 2C4.5 0.895431 3.60457 0 2.5 0C1.39543 0 0.5 0.895431 0.5 2C0.5 3.10457 1.39543 4 2.5 4ZM2.5 12C3.60457 12 4.5 11.1046 4.5 10C4.5 8.89543 3.60457 8 2.5 8C1.39543 8 0.5 8.89543 0.5 10C0.5 11.1046 1.39543 12 2.5 12ZM12.5 2C12.5 3.10457 11.6046 4 10.5 4C9.39543 4 8.5 3.10457 8.5 2C8.5 0.895431 9.39543 0 10.5 0C11.6046 0 12.5 0.895431 12.5 2ZM10.5 12C11.6046 12 12.5 11.1046 12.5 10C12.5 8.89543 11.6046 8 10.5 8C9.39543 8 8.5 8.89543 8.5 10C8.5 11.1046 9.39543 12 10.5 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2V6C4.70914 6 6.5 4.20914 6.5 2H2.5ZM2.5 2H6.5C6.5 -0.209139 4.70914 -2 2.5 -2V2ZM2.5 2V-2C0.290861 -2 -1.5 -0.209139 -1.5 2H2.5ZM2.5 2H-1.5C-1.5 4.20914 0.290861 6 2.5 6V2ZM2.5 10V14C4.70914 14 6.5 12.2091 6.5 10H2.5ZM2.5 10H6.5C6.5 7.79086 4.70914 6 2.5 6V10ZM2.5 10V6C0.290861 6 -1.5 7.79086 -1.5 10H2.5ZM2.5 10H-1.5C-1.5 12.2091 0.290861 14 2.5 14V10ZM10.5 6C12.7091 6 14.5 4.20914 14.5 2H10.5V6ZM6.5 2C6.5 4.20914 8.29086 6 10.5 6V2H6.5ZM10.5 -2C8.29086 -2 6.5 -0.209139 6.5 2H10.5V-2ZM14.5 2C14.5 -0.209139 12.7091 -2 10.5 -2V2H14.5ZM10.5 10V14C12.7091 14 14.5 12.2091 14.5 10H10.5ZM10.5 10H14.5C14.5 7.79086 12.7091 6 10.5 6V10ZM10.5 10V6C8.29086 6 6.5 7.79086 6.5 10H10.5ZM10.5 10H6.5C6.5 12.2091 8.29086 14 10.5 14V10Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1643:13831)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragPoints);
export default __webpack_public_path__ + "static/media/drag_points.f94fe256.svg";
export { ForwardRef as ReactComponent };